import Input, { InputProps } from './Input';

export type CurrencyInputProps = {
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
} & Omit<InputProps, 'type'>;

// Test for a number with the format: 10.11, 0.01, 1000, .1 e.g.
const regex = /^-?(\d+(\.\d{0,2})?|\.\d{0,2})$/;

function validator(val: string): boolean {
    return regex.test(val);
}

function CurrencyInput({ onChange, ...props }: CurrencyInputProps): JSX.Element {
    /**
     * Checks if the entered number can be parsed.
     * @param e Change event
     * @returns
     */
    function handleChange(e: React.ChangeEvent<HTMLInputElement>): void {
        const val = e.target.value;
        if (val === '.') {
            onChange(e);
            return;
        }

        // Strip all non numeric values
        const stripped = val.replace(/[^0-9.]/g, '');
        if (isNaN(+stripped)) {
            return;
        }

        e.target.value = stripped;
        onChange(e);
    }

    function handleBlur(e: React.FocusEvent<HTMLInputElement, Element>): void {
        const val = e.target.value.trim();

        if (val === '.') {
            onChange({ ...e, target: { ...e.target, value: '0.00' } });
            return;
        }

        if (isNaN(+val) || val === '') {
            return;
        }

        onChange(e);
        if (props.onBlur) {
            props.onBlur(e);
        }
    }

    return (
        <Input
            type="text"
            {...props}
            textAlign={props.textAlign || 'right'}
            value={props.value}
            onChange={handleChange}
            onBlur={handleBlur}
            // validator={validator}
        />
    );
}

function padDecimalPlaces(val: string, places = 2): string {
    const [whole, fraction] = val.split('.');
    if (!fraction) {
        return `${whole}.00`;
    }
    if (fraction.length === 1) {
        return `${whole}.${fraction}0`;
    }
    return val;
}

export default CurrencyInput;
